// extracted by extract-css-chunks-webpack-plugin
module.exports = {"ArticleImage":"ArticleImage","ArticleImage--left":"ArticleImage--left","ArticleImage--right":"ArticleImage--right","ArticleImage__caption":"ArticleImage__caption"};